// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// CC-Common imports
import { IconConstants } from 'cc-common';

// 3rd party imports
import { Column } from 'devextreme/ui/data_grid';

@Component({
    selector: 'app-grid-option-selector',
    templateUrl: './grid-option-selector.component.html',
    styleUrls: ['./grid-option-selector.component.scss']
})
export class GridOptionSelectorComponent {
    @Input() source: any[];
    @Input() columns: Column[];
    @Input() keyExpr: string | string[];
    @Input() noDataText = 'No Data Found!';
    @Input() filterRow: any = { visible: false };
    @Input() selectionMode: any = { mode: 'none' };

    @Output() onSelection = new EventEmitter<any>();
    @Output() onMultiSelection = new EventEmitter<any[]>();

    iconCheck = IconConstants.CHECK;
    iconCross = IconConstants.CROSS;
    selectedRow = null;

    onSelectClick(record: any): void {
        this.selectedRow = record;
        this.onSelection.emit(record);
    }

    onSelectionChanged(e: any): void {
        if (this.selectionMode.mode === 'single') {
            this.onSelectClick(e.selectedRowsData[0]);
        } else if (this.selectionMode.mode === 'multiple') {
            this.onMultiSelection.emit(e.selectedRowsData);
        }
    }

    isSelectedRow(rec: any): boolean {
        return !!this.selectedRow && this.selectedRow[this.keyExpr.toString()] === rec[this.keyExpr.toString()];
    }
}
